module.exports = __webpack_public_path__ + "img/defaultAnnouncement1.6889cd9e.jpg";